import React, { useState } from "react";
import { motion } from "framer-motion";
import Input from "../../app/components/Input";
import Button from "../../app/components/Button";
import { FiX } from "react-icons/fi";
import { z } from "zod";
import { urlSchema } from "../../Validations/schemas";

const AccessAdd = ({ onClose, onSave }) => {
  const [formData, setFormData] = useState({
    plataforma: "",
    link: "",
    usuario: "",
    senha: "",
    observacao: "",
  });

  const [errors, setErrors] = useState({});

  const handleChange = (field) => (e) => {
    const value = e?.target?.value ?? e;

    setFormData((prev) => ({ ...prev, [field]: value }));

    if (value.trim() === "") {
      setErrors((prev) => ({ ...prev, [field]: "" }));
      return;
    }

    try {
      if (field === "link") {
        urlSchema.parse(value);
        setErrors((prev) => ({ ...prev, link: "" }));
      }
    } catch (error) {
      if (error instanceof z.ZodError) {
        setErrors((prev) => ({
          ...prev,
          [field]: error.errors[0].message,
        }));
      }
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    try {
      urlSchema.parse(formData.link);
      onSave(formData);

      setFormData({
        plataforma: "",
        link: "",
        usuario: "",
        senha: "",
        observacao: "",
      });

      setErrors({});
    } catch (error) {
      if (error instanceof z.ZodError) {
        setErrors((prev) => ({
          ...prev,
          link: error.errors[0].message,
        }));
      }
    }
  };

  const panelVariants = {
    hidden: { x: 400, opacity: 0 },
    visible: {
      x: 0,
      opacity: 1,
      transition: { type: "spring", stiffness: 300, damping: 30 },
    },
    exit: {
      x: 400,
      opacity: 0,
      transition: { duration: 0.2, ease: "easeInOut" },
    },
  };

  return (
    <motion.div
      className="fixed bottom-8 z-[999]"
      style={{ right: "500px", width: "400px" }}
      initial="hidden"
      animate="visible"
      exit="exit"
      variants={panelVariants}
    >
      <div className="bg-white shadow-2xl rounded-2xl flex flex-col overflow-y-auto p-6 space-y-6">
        <div className="flex items-center justify-between mb-4">
          <h2 className="text-lg font-semibold text-gray-900">Adicionar Acesso</h2>
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700 p-1"
            aria-label="Fechar"
          >
            <FiX />
          </button>
        </div>

        <form
          onSubmit={handleSubmit}
          className="space-y-4 flex-1 flex flex-col justify-between"
        >
          <div className="space-y-4">
            <Input
              label="Plataforma"
              required
              value={formData.plataforma}
              onChange={handleChange("plataforma")}
            />

            <div>
              <Input
                label="Link de acesso"
                value={formData.link}
                onChange={handleChange("link")}
                required
                error={!!errors.link}
              />
              {errors.link && (
                <p className="text-red-500 text-sm mt-[-0.95rem]">{errors.link}</p>
              )}
            </div>

            <Input
              label="Usuário"
              value={formData.usuario}
              onChange={handleChange("usuario")}
            />

            <Input
              label="Senha"
              value={formData.senha}
              onChange={handleChange("senha")}
            />

            <div className="relative w-full mb-5">
              <textarea
                id="observacao"
                name="observacao"
                placeholder=" "
                value={formData.observacao}
                onChange={handleChange("observacao")}
                className="peer block w-full appearance-none border border-gray-300 rounded-tl-2xl rounded-tr-2xl rounded-br-2xl p-3 min-h-[100px] focus:outline-none focus:ring-1 focus:ring-purple-500/25 focus:border-purple-700 transition-all"
              />
              <label
                htmlFor="observacao"
                className="absolute left-4 bg-white px-1 text-sm text-gray-500 transition-all duration-75 ease-in pointer-events-none peer-placeholder-shown:top-3 peer-focus:top-[-0.5rem] peer-focus:translate-y-0 peer-focus:text-purple-700"
              >
                Observações
              </label>
            </div>
          </div>

          <div className="grid grid-cols-2 gap-3 mt-6">
            <Button variant="secondary" onClick={onClose} type="button">
              Cancelar
            </Button>
            <Button variant="primary" type="submit">
              Salvar
            </Button>
          </div>
        </form>
      </div>
    </motion.div>
  );
};

export default AccessAdd;
